import { motion } from "framer-motion";
import { BOOK } from "../lib/content";

export const Manifesto = () => (
  <section id="capitulos" className="py-24 sm:py-32 lg:py-40" data-testid="chapters-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.9 }}
        className="mb-20 max-w-2xl"
      >
        <span className="label-eyebrow">El recorrido de este partido</span>
        <h2 className="mt-6 font-display font-semibold uppercase text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight">
          Ocho capítulos, <span className="text-gold">un solo partido</span>
        </h2>
        <p className="mt-6 text-base sm:text-lg leading-relaxed text-[#A19F9A] font-light">
          De la pasión como hilo conductor al legado que queda cuando se apagan las luces del estadio.
        </p>
      </motion.div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {BOOK.chapters.map((ch, i) => (
          <motion.article
            key={ch.number}
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay: (i % 4) * 0.12 }}
            className="card-glow relative border border-white/8 bg-[#12121A]/60 p-8 flex flex-col min-h-[280px]"
            data-testid={`chapter-card-${ch.number}`}
          >
            <span
              className="font-display font-bold text-6xl leading-none text-transparent select-none"
              style={{ WebkitTextStroke: "1px rgba(197,160,89,0.5)" }}
            >
              {ch.number}
            </span>
            <h3 className="mt-6 font-display font-medium uppercase text-lg tracking-wide leading-snug">{ch.title}</h3>
            <p className="mt-4 text-sm leading-relaxed text-[#A19F9A] font-light flex-1">{ch.teaser}</p>
          </motion.article>
        ))}
      </div>
    </div>
  </section>
);
